const calculateValueCheque = (percent, price, day_left) => {
  day_left = parseFloat(day_left);
  percent = parseFloat(percent);
  price = parseFloat(price);

  let a = (day_left / 30) * (percent / 100) + 1;
  a = parseFloat(parseInt(a * 100000) / 100000);

  return Math.round(parseInt(price / a) / 1000) * 1000;
};

export default calculateValueCheque;
